module.exports = __webpack_public_path__ + "static/media/square.c0c8b61c.webp";